import React, { useEffect, useState } from 'react';
import './CourseChapters.css';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../RefreshToken/RefreshToken';
import { API } from '../../../constants';
import { toast } from 'react-toastify';

const CourseChapters = () => {
    const [openChapterIndex, setOpenChapterIndex] = useState(null);
    const { enrollmentId } = useParams();
    const [course, setCourse] = useState(null);
    const [coursesPerPage, setCoursesPerPage] = useState(8);
    const navigate = useNavigate()

    const toggleChapter = (index) => {
        setOpenChapterIndex(prev => prev === index ? null : index);
    }

    useEffect(() => {
        api.get(`${API}/student/learning/${enrollmentId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        }).then((response) => {
            setCourse(response.data.course.chapters);
        }).catch((error) => {
            toast.error(`Error fetching courses: ${error?.message || "Unknown error"}`);
        });

        const handleResize = () => {
            if (window.innerWidth <= 550) {
                setCoursesPerPage(4);
            } else {
                setCoursesPerPage(8);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [lessonsDetail, setLessonsDetail] = useState([])
    const handleOpenChapter = (chapterId) => {
        api.get(`/student/learning/${enrollmentId}/${chapterId}/lessons`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }).then(res => {
            setLessonsDetail(res.data);
        }).catch((err) => {
            console.log("error", err)
        })
    }

    const handleRedirect = (lesson, chapterId) => {
        console.log(lesson)
        navigate(`/student/courses/${enrollmentId}/${chapterId}/${lesson?.order}`);
        window.location.reload();
    };

    return (
        <div className='course-chapters resize-chapters'>
            <h1 className='course-chapters-title'>Course Chapters</h1>
            <ol className="chapters-list">
                {course && course.map((chapter, index) => (
                    <li
                        onClick={() => { toggleChapter(index); handleOpenChapter(chapter.id) }}
                        className="chapters-item-block"
                        key={index}
                    >
                        <h3 className="chapters-item">{index + 1}. {chapter.title}</h3>
                        {openChapterIndex === index && (
                            <div className="chapters-item-content">
                                {lessonsDetail?.slice().sort((a, b) => a.order - b.order).map((lesson, index) => (
                                    <p onClick={() => handleRedirect(lesson, chapter?.id)} className="chapters-item">{index + 1}. {lesson.title} </p>
                                ))}
                            </div>
                        )}
                    </li>
                ))}
            </ol>
        </div>
    );
}

export default CourseChapters;
